import React, { useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SocialMedia from "../components/SocialMedia";
import { CartContext } from "../Context/Context";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  const {Theme}  = useContext(CartContext)
  return (
    <Container fluid className={`footer${Theme}`}>
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Developed with ❤️ by Ritik</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} </h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Ready to give my best! </h3>
          <h3>
Open to work! </h3>
        </Col>
         
     
      </Row>
    </Container>
  );
}

export default Footer;
